export enum LotteryType {
  // HOURLY = 'hourly',
  // DAILY = 'daily',
  FREE = 'free',
  DEPOSIT = 'deposit',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}
